import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@core/interface/api-response.interface';
import { CompanyCollectorCommissionRuleService } from '@core/services/entities/company-collector-commission-rule.service';
import { CompanyCollectorCommissionRuleRepository } from '@domain/company-collector-commission-rule/repositories/company-collector-commission-rule.repository';
import { SimulateCommissionRequestDto } from '@domain/company-collector-commission-rule/dtos/simulate-commission-request.dto';
import { SimulateCommissionResponseDto } from '@domain/company-collector-commission-rule/dtos/simulate-commission-response.dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorCommissionRuleRepositoryService implements CompanyCollectorCommissionRuleRepository {
  constructor(private service: CompanyCollectorCommissionRuleService) {}

  simulate(
    request: SimulateCommissionRequestDto,
  ): Observable<ApiResponse<SimulateCommissionResponseDto>> {
    return this.service.simulate(request);
  }
}
